import { Button } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { AddCircleOutlineOutlined } from '@material-ui/icons';
import { useSelector } from 'react-redux';
import SingleSlab from './SingleSlab';
import { getFilteredSlabInputs, getSlabEmptyTemplate, isEmptySlabAlreadyExist, isUnsavedSlabPresentInRedux } from './service';
import { addApplicableSlab, resetSlabInfo, updateApplicableSlabUnit, updateSlabInfoQuantityUnit } from '../../../../../stateManagement/actions/manageCouponActions';
import { APPLICABLE_SLABS_INPUTS, COUPON_TYPE_OPTIONS_VALUE, labelMappings, getApplicableSlabsInputs } from '../../../utils/utils';
import ValueQtySwitch from './ValueQtySwitch';
import { deepClone } from '@mui/x-data-grid/utils/utils';
import PeiceCaseSwitch from './PeiceCaseSwitch';
import { isSlabInfoEmpty } from '../../validationPopup/validationService';
import { ConfirmationPopUp } from '../../../../../components/popup/confirmationPopUp';
import { useCouponAlert } from '../../../context/CouponAlert';
import { APPLICABLE_SLABS_INPUTS_types, slabInfoType } from '../../../types';


function ApplicableSlab() {
    const { data:slabsData , slabUnit ,quantityUnit} = useSelector((state: any) => state?.manageCoupons?.data?.slabInfo);
    const { couponTypeOption} = useSelector((state: any) => state?.manageCoupons?.data);
    const [inputs , setInputs] = useState<APPLICABLE_SLABS_INPUTS_types[]>(deepClone(getApplicableSlabsInputs()));
    const [confirmationDetails , setConfirmationDetails] = useState<{message:string,open:boolean}>({message:'',open:false})
    
    const {showAlert} = useCouponAlert();

    const isAnyDataTypedRef = useRef<boolean>(false);
    const successMethodRef = useRef<()=>void>(()=>{});


    const handleAddMoreClick = () => {
        const isEmptyPresent = isEmptySlabAlreadyExist(inputs);
        if (isEmptyPresent) {
            showAlert(labelMappings["applicable-slab-empty-template-exist"],'warning')
            return;
        }
        addApplicableSlab(getSlabEmptyTemplate());
    }

    const handleSlabQtyChange = (val:string)=>{
        if(slabUnit === val) return;

        if( val.toLowerCase() === labelMappings["applicable-slab-qty"].toLowerCase() &&  (couponTypeOption=== COUPON_TYPE_OPTIONS_VALUE.TOTAL_ORDER_WELCOME || couponTypeOption === COUPON_TYPE_OPTIONS_VALUE.TOTAL_ORDER_VALUE)){
            showAlert(labelMappings["VALUE_QTY_SWITCH_DISABLED_MESSAGE"],'warning')
            return;
        }

        if(!isSlabInfoEmpty()){
            showAlert(labelMappings["APPLICABLE_SLAB_INVALID_UNIT_CHANGE"],'warning')
            return;
        }

        if(isUnsavedSlabPresentInRedux(inputs) || isAnyDataTypedRef.current){
            setUnitChangeConfirmation(val);
            return ;
        }   
        
        updateApplicableSlabUnit(val);
    }

    const setUnitChangeConfirmation = (val:string)=>{
        successMethodRef.current = ()=>{
            resetSlabInfo();
            updateApplicableSlabUnit(val);
            isAnyDataTypedRef.current = false;
        }
        setConfirmationDetails({message:labelMappings["APPLICABLE_SLAB_UNIT_CHANGE_CONFIRMATION"],open:true});
        
    }

    const handleQuantityUnitChange = (val:string)=>{
        if(quantityUnit === val) return;

        if(!isSlabInfoEmpty()){
            showAlert(labelMappings["APPLICABLE_SLAB_INVALID_UNIT_CHANGE"],'warning');
            return;
        }

        updateSlabInfoQuantityUnit(val);
    }

    useEffect(() => {
        if (slabsData.length === 0) {
            addApplicableSlab(getSlabEmptyTemplate());
        }
    }, [slabsData])

    useEffect(()=>{
        const ans = getFilteredSlabInputs()
        setInputs(ans);
    },[couponTypeOption])

    return (
        <div>
            <div className='applicable-slab-wrapper'>
                <div className="applicable-slab-wrapper-header">
                    <div style={{display:'flex',gap:'10px'}}>
                        <ValueQtySwitch onChange={handleSlabQtyChange} value={slabUnit}/>
                        {
                           slabUnit.toLowerCase() === "qty" && <PeiceCaseSwitch onChange={handleQuantityUnitChange} value={quantityUnit}/>
                        }
                    </div>
                    
                    <Button className='applicable-slab-addmore-btn' onClick={handleAddMoreClick} size='small' startIcon={<AddCircleOutlineOutlined />}>Add More</Button>
                </div>
                <div className="applicable-slab-wrapper-content">
                    {
                        slabsData.map((slab: slabInfoType) => {
                            return <SingleSlab 
                                    key={slab.id} 
                                    slab={slab} 
                                    isAnyDataTypedRef={isAnyDataTypedRef}
                                    slabUnit={slabUnit} 
                                    inputs={inputs}
                                    />
                        })
                    }

                </div>
            </div>

            <ConfirmationPopUp
                message={confirmationDetails.message}
                openConfirmModal={confirmationDetails.open}
                setOpenConfirmModal={(val)=>setConfirmationDetails(()=>({message:"",open:val as boolean}))}
                successMethod={successMethodRef.current}
            />

        </div>
    )
}

export default ApplicableSlab